import { Component, Input } from '@angular/core';

@Component({
  selector: 'bst-cv-studio-pane-theme',
  templateUrl: './studio-pane-theme.component.html',
  styleUrls: ['./studio-pane-theme.component.scss'],
  standalone: false,
})
export class StudioPaneThemeComponent {
  @Input() clientId!: number;
}
